import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../../components/Layout';
import Menu from '../../../../../components/Layout/Menu';

const SubCategoryCreateContent = lazy(
  () => import('../../../../../components/Pages/Categories/[categoryId]/SubCategories/Create'),
);

export default function SubCategoryCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Tipping sub category create`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <SubCategoryCreateContent />
      </Suspense>
    </Layout>
  );
}
